import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './Dashboard';
import AR7CheatSheet from './AR7CheatSheet';
import PriceCapExplainer from './PriceCapExplainer';
import Forecast2030 from './Forecast2030';
import Wholesale from './Wholesale';
import NavBar from './NavBar';

function App() {
  return (
    <Router>
      <NavBar />
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/ar7-cheat-sheet" element={<AR7CheatSheet />} />
        <Route path="/price-cap" element={<PriceCapExplainer />} />
        <Route path="/hedging-is-hot" element={<PriceCapExplainer />} />
        <Route path="/2030" element={<Forecast2030 />} />
        <Route path="/wholesale" element={<Wholesale />} />
      </Routes>
    </Router>
  );
}

export default App;
